'use client';

import GridEditIcon from '@/components/icons/GridEditIcon';
import { usePathname, useRouter } from '@/i18n/navigation';
import { useSearchParams } from 'next/navigation';
import GlobalIcon from '../icons/global-icon';
import ArrowIcon from '../icons/arrow-icon';
import { useLocale } from 'next-intl';
import { change_language_event } from '@/utils/gtm';

export default function LocaleSwitcher({ isSide = false, onClose }) {
  const locale = useLocale();
  const pathname = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();

  const changeLocale = () => {
    const newLocale = locale === 'ar' ? 'en' : 'ar';

    const queryString = searchParams.toString();
    const newPath = queryString ? `${pathname}?${queryString}` : pathname;
    change_language_event(newLocale);
    router.push(newPath, { locale: newLocale });
    onClose && onClose();
  };

  if (isSide)
    return (
      <button
        aria-label='Language'
        value={locale}
        onClick={changeLocale}
        className='flex cursor-pointer items-center justify-between p-4'
      >
        <div className='flex items-start gap-2'>
          <GridEditIcon />
          <div className='text-start'>
            <p className='text-xs font-normal text-black'>
              {locale === 'en' ? 'Change Language' : 'تغيير اللغة'}
            </p>
            <p className='text-[10px] font-normal text-[#959595]'>
              {locale === 'ar' ? 'English' : 'العربية'}
            </p>
          </div>
        </div>
        <ArrowIcon
          className='size-2.5 rotate-270 rtl:rotate-90'
          strokeWidth={2}
        />
      </button>
    );

  return (
    <button
      aria-label='Language'
      value={locale}
      onClick={changeLocale}
      className='flex cursor-pointer items-center gap-1 lg:gap-2'
    >
      <GlobalIcon className='size-3 sm:size-4' />
      <span className='text-[10px] sm:text-xs'>
        {locale === 'en' ? 'العربية' : 'EN'}
      </span>
      <ArrowIcon className='h-1 w-2 sm:size-2' />
    </button>
  );
}
